import React from 'react';
import { ChevronUp, ChevronDown } from 'lucide-react';
import { Box, TableCell, TableRow, TableHead, Typography } from '@mui/material';

const TableHeader = ({ columns = [], sortConfig, onSort }) => {
  const handleSort = (key) => {
    try {
      if (
        !onSort ||
        !columns.find((column) => column.field === key && column.isSortable)
      ) {
        return;
      }

      let direction = 'asc';
      if (
        sortConfig &&
        sortConfig.key === key &&
        sortConfig.direction === 'asc'
      ) {
        direction = 'desc';
      }

      onSort(key, direction);
    } catch (error) {
      console.error('Error: ', error);
    }
  };

  return (
    <TableHead>
      <TableRow>
        {columns.map((column) => (
          <TableCell
            width={column?.width}
            key={column.field || crypto.randomUUID()}
            onClick={() => handleSort(column.field)}
            sx={{
              backgroundColor: (theme) => theme.palette.background.default,
              borderBottom: '2px solid',
              borderColor: 'divider',
              padding: '16px',
              cursor: column.sortable ? 'pointer' : 'default',
              transition: 'background-color 0.2s ease-in-out',
              userSelect: 'none',
              '&:hover': column.sortable ? {
                backgroundColor: (theme) => theme.palette.action.hover
              } : {},
              textAlign: column.headerAlign || 'left'
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.5,
                justifyContent: column.headerAlign || 'left'
              }}
            >
              <Typography
                variant='subtitle2'
                sx={{
                  fontWeight: 600,
                  color: 'text.primary',
                  textTransform: 'uppercase',
                  fontSize: '0.75rem',
                  letterSpacing: '0.5px'
                }}
              >
                {column.headerName}
              </Typography>
              {column.sortable && (
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    color: sortConfig?.key === column.field ? 'primary.main' : 'text.disabled',
                    transition: 'transform 0.2s ease-in-out, color 0.2s ease-in-out'
                  }}
                >
                  {sortConfig?.key === column.field ? (
                    sortConfig.direction === 'asc' ? (
                      <ChevronUp size={16} />
                    ) : (
                      <ChevronDown size={16} />
                    )
                  ) : (
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        opacity: 0.3,
                        '& svg': {
                          height: '12px',
                          width: '12px'
                        }
                      }}
                    >
                      <ChevronUp />
                      <ChevronDown style={{ marginTop: -8 }} />
                    </Box>
                  )}
                </Box>
              )}
            </Box>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default TableHeader;
